// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"121":"gallery","548":"calendar"}[chunkId] + "." + {"121":"8ef3570d","548":"620bfd74"}[chunkId] + ".js";
};